import React from 'react';

/**
 * NumberedMarquee — Two horizontally scrolling rows of numbered items in opposite directions.
 * Inspired by editorial design sites (e.g. Gardyn). Pure CSS animation.
 */
export default function NumberedMarquee({ items, accent = '#6A8F3E' }) {
  const numbered = items.map((label, i) => ({
    n: String(i + 1).padStart(2, '0'),
    label,
  }));

  return (
    <section className="relative border-y border-[#E7E9E4]/8 bg-[#314F2B] overflow-hidden">
      {/* Single row — left direction */}
      <div className="flex whitespace-nowrap marquee-inner py-5 md:py-6">
        {[...Array(2)].map((_, k) => (
          <div key={`r-${k}`} className="flex items-center gap-14 px-7 flex-shrink-0">
            {numbered.map((it, i) => (
              <React.Fragment key={`r-${k}-${i}`}>
                <div className="flex items-baseline gap-4">
                  <span
                    className="font-sans-brand text-[11px] tracking-[0.35em] uppercase font-bold"
                    style={{ color: accent }}
                  >
                    {it.n}.
                  </span>
                  <span className="font-sans-brand uppercase text-[#E7E9E4] font-extrabold tracking-tight"
                        style={{ fontSize: 'clamp(1.1rem, 2.6vw, 2.6rem)' }}>
                    {it.label}
                  </span>
                </div>
                <span className="w-2 h-2 rounded-full" style={{ background: accent }} />
              </React.Fragment>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
